import React from "react";

export type TLinkIconProps = React.SVGAttributes<SVGElement>;

/**
 * Link/chain icon exported from Figma (link_2).
 */
export function LinkIcon({ fill = "currentColor", ...rest }: TLinkIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 17.975 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.95 18C3.58333 18 2.41667 17.5167 1.45 16.55C0.483333 15.5833 0 14.4167 0 13.05C0 12.3833 0.125 11.75 0.375 11.15C0.625 10.55 0.983333 10.0167 1.45 9.55L4.8 6.225L6.2 7.625L2.85 10.975C2.56667 11.2583 2.35417 11.5792 2.2125 11.9375C2.07083 12.2958 2 12.6667 2 13.05C2 13.8667 2.2875 14.5625 2.8625 15.1375C3.4375 15.7125 4.13333 16 4.95 16C5.33333 16 5.70833 15.9292 6.075 15.7875C6.44167 15.6458 6.76667 15.4333 7.05 15.15L10.375 11.8L11.8 13.225L8.45 16.55C7.98333 17.0167 7.45 17.375 6.85 17.625C6.25 17.875 5.61667 18 4.95 18ZM6.925 12.5L5.5 11.075L11.075 5.5L12.5 6.925L6.925 12.5ZM13.2 11.8L11.8 10.375L15.15 7.05C15.4333 6.76667 15.6417 6.45 15.775 6.1C15.9083 5.75 15.975 5.38333 15.975 5C15.975 4.16667 15.6917 3.45833 15.125 2.875C14.5583 2.29167 13.8583 2 13.025 2C12.6417 2 12.2708 2.07083 11.9125 2.2125C11.5542 2.35417 11.2333 2.56667 10.95 2.85L7.625 6.2L6.2 4.8L9.55 1.45C10.0167 0.983333 10.55 0.625 11.15 0.375C11.75 0.125 12.3833 0 13.05 0C14.4167 0 15.5792 0.483333 16.5375 1.45C17.4958 2.41667 17.975 3.59167 17.975 4.975C17.975 5.625 17.8542 6.25 17.6125 6.85C17.3708 7.45 17.0167 7.98333 16.55 8.45L13.2 11.8Z"
        fill={fill}
      />
    </svg>
  );
}
